<template>
  <div class="NewsList">
    <div class="DisplayFlex">
      <div class="mainTitle" :style="props.NewsCompConfig.style || ''">
        <p>{{ props.NewsCompConfig.title }}</p>
        <p>{{ props.NewsCompConfig.eTitle }}</p>
      </div>
      <div class="SeeMore" :style="props.NewsCompConfig.style || ''">
        <p>
          <span
            @click="
              $router.push({
                path: props.NewsCompConfig.path,
                query: { c: props.NewsCompConfig.cate_id },
              })
            "
            >查看更多</span
          >
          <span class="iconfont iconarrowright"></span>
        </p>
      </div>
    </div>
    <div v-if="props.NewsCompConfig.roll && state.NewsList.length >= 5">
      <Vue3SeamlessScroll
        v-if="state.NewsList.length > 0"
        :copyNum="1"
        :hover="true"
        :limitScrollNum="5"
        :list="state.NewsList"
        :step="0.3"
        :wheel="false"
        class="tabData"
      >
        <div
          v-for="(item, index) in state.NewsList"
          :key="index"
          class="newslist"
        >
          <p>
            <span>&sdot;</span>
            <span class="oneline-overflow-elision" @click="GoToDetails(item)">{{
              item.title
            }}</span>
            <span>{{ state.typeList[item.type].label }}</span>
          </p>
        </div>
      </Vue3SeamlessScroll>
    </div>
    <div v-else>
      <div
        v-for="(item, index) in state.NewsList"
        :key="index"
        class="newslist"
      >
        <p>
          <span>&sdot;</span>
          <span class="oneline-overflow-elision" @click="GoToDetails(item)">{{
            item.title
          }}</span>
          <span>{{ item?.add_time?.substring(0, 10) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import * as Vue from "vue";
import router from "@/router";
import api from "@/comment/request/api";
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";

export default {
  name: "NewsComp",
  components: { Vue3SeamlessScroll },
  props: ["NewsCompConfig", "topic", "pageN"],
  setup(props, { attrs, slots, emit }) {
    const state = Vue.reactive({
      NewsList: [],
      typeList: [
        {value: null, label: '全部'},
        {value: 1, label: '理事长单位'},
        {value: 2, label: '副理事长单位'},
        {value: 3, label: '会员单位'},
      ]
    });
    // 列表
    const InitNews = () => {
      let num = props.pageN ? props.pageN : 7;
      api.GetDataList(props.NewsCompConfig.url, { cate_id: props.NewsCompConfig.cate_id || '', limit: num }).success((res) => {
        state.NewsList = res.data.data.data;
        emit("data", res.data.data.data);
      });
    };
    InitNews();
    // 详情
    const GoToDetails = (item) => {
      router.push({
        name: props.NewsCompConfig.detail,
        query: {
          id: item[props.NewsCompConfig.id],
        },
      });
    };
    return {
      state,
      props,
      GoToDetails,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "/src/comment/comment";

.tabData {
  height: 204px;
  overflow: hidden;
}

.NewsList {
  .DisplayFlex {
    border-bottom: 5px solid #d8d8d8;
    position: relative;
  }
  .NoBottom {
    border-bottom: none;
    display: flex;
    align-items: center;
    /deep/.SeeMore {
      bottom: auto;
    }
  }
  .mainTitle {
    width: calc(100% - 100px);
    margin-top: 12px;
    //margin-left: 30px;
    padding-bottom: 10px;
    line-height: 24px;
  }
  .topicTitle {
    display: flex;
    > p {
      margin-right: 10px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      line-height: 24px;
      margin-bottom: 10px;
      color: #d8d8d8;
      cursor: pointer;
    }
    .active {
      color: #008fd7;
    }
    > p:not(p:last-child):after {
      content: "|";
      color: #d8d8d8;
      font-weight: lighter;
      margin-left: 10px;
    }
  }
  .topicTitleTwo {
    width: 100%;
    background-color: #f1f1f1;
    display: flex;
    padding-left: 20px;
    p {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
      margin: 4px;
      padding: 9px 20px;
      cursor: pointer;
    }
    .active {
      font-weight: 600;
      color: #008fd7;
      background-color: #ffffff;
    }
  }
  .SeeMore {
    width: 100px;
    position: absolute;
    right: 0;
    bottom: 5px;
  }

  .newslist {
    //margin-left: 30px;
    p {
      padding: 8px 0;
      overflow: hidden;
      border-bottom: 1px solid #d8d8d8;

      span {
        float: left;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        //font-weight: 600;
        color: #333333;
      }

      span:nth-child(1) {
        margin-right: 7px;
      }

      span:nth-child(2) {
        width: calc(100% - 120px);
        display: inline-block;
        cursor: pointer;

        &:hover {
          color: #008fd7;
          //font-weight: 600;
        }
      }

      span:nth-child(3) {
        float: right;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.noPointer {
  span {
    cursor: auto;
  }
}
.pr10 {
  padding-right: 10px;
}
</style>